import dayjs from "dayjs";

import { type DSSCalendarEvent } from "./DSSCalendar.types";

export const getEventsForDate = (
  events: DSSCalendarEvent[],
  date: string,
): DSSCalendarEvent[] => events.filter(event => event.date === date);

export const hasEvents = (events: DSSCalendarEvent[], date: string): boolean =>
  events.some(event => event.date === date);

export const filterEventsByMonth = (
  events: DSSCalendarEvent[],
  month: string,
): DSSCalendarEvent[] =>
  events.filter(event => dayjs(event.date).format("YYYY-MM") === month);
